export default {"src":"/_next/static/media/no-deposit.5bf49278.svg","height":117,"width":150};